import React from 'react';

export function XIcon() {

    return (
        <span className='text-primary font-bold animate-pulse'>X</span>

    );
}
